<script lang="ts">
    // import iconExpandUp from "../../../assets/expand_circle_up_FILL0_wght400_GRAD0_opsz24.svg";
    // import iconExpandDown from "../../../assets/expand_circle_down_FILL0_wght400_GRAD0_opsz24.svg";
    import iconExpandUp from './svg/expand_less_FILL0_wght400_GRAD0_opsz24.svg';
    import iconExpandDown from './svg/expand_more_FILL0_wght400_GRAD0_opsz24.svg';

    export let isOpen = false;
</script>

<img src={isOpen ? iconExpandUp : iconExpandDown} alt="show/hide" on:click />
